import { render, staticRenderFns } from "./otherFileSettings.vue?vue&type=template&id=09964b60&scoped=true"
import script from "./otherFileSettings.vue?vue&type=script&lang=js"
export * from "./otherFileSettings.vue?vue&type=script&lang=js"
import style0 from "./otherFileSettings.vue?vue&type=style&index=0&id=09964b60&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09964b60",
  null
  
)

export default component.exports